import React, { createContext, useContext } from "react";
import { connect } from "react-redux";

const GameSettingsContext = createContext();

export function useGameSettings() {
  return useContext(GameSettingsContext);
}
export const SettingsProvider = connect((state) => ({
  settings: state.forms?.gameSettings?.data || {},
}))(({ children, settings }) => {
  return (
    <GameSettingsContext.Provider value={settings}>
      {children}
    </GameSettingsContext.Provider>
  );
});
